import { render, staticRenderFns } from "./JobSkills.vue?vue&type=template&id=35726af8&"
import script from "./JobSkills.vue?vue&type=script&lang=js&"
export * from "./JobSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports